import { render, staticRenderFns } from "./page-view.vue?vue&type=template&id=06dc4aa6&scoped=true"
import script from "./page-view.vue?vue&type=script&lang=js"
export * from "./page-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dc4aa6",
  null
  
)

export default component.exports